
import banner from './banner'
import thankYouPrompt from './thankYouPrompt'

export default { banner , thankYouPrompt } 
